var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chipLabel",style:({
		'background-color': _vm.bgColor,
		'color': _vm.textColor,
		'font-weight': 'bold'
	})},[_vm._v(" "+_vm._s(_vm.value.replace('_', ' '))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }